import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { media } from '../styles';

const propTypes = {
  id: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  condensed: PropTypes.bool,
  full: PropTypes.bool,
  sectionContainer: PropTypes.bool,
  style: PropTypes.object
};


/**
 * The Container component, used to provide prebuilt styling for specific container sections.
 *
 * @param {bool} condensed - adjusts max-width, padding
 * @param {bool} full - adjusts max-width
 * @param {bool} sectionContainer - adjusts max-width, padding, position, & flex properties
 * @param {css} style - passed in to use inline stlying 
 *
 * @returns {JSX}
 */
const Container = props => {
  const { 
    id,
    children, 
    className, 
    condensed = false, 
    full = false, 
    sectionContainer = false, 
    awardContainer = false,
    style 
  } = props;

  return (
    <Wrapper
      id={id}
      className={className}
      condensed={condensed}
      full={full}
      sectionContainer={sectionContainer}
      awardContainer={awardContainer}
      style={style}
    >
      {children}
    </Wrapper>
  );
};

Container.propTypes = propTypes;

const Wrapper = styled.div`
  margin: auto;
  max-width: ${({ full, condensed }) => (full ? 'none' : condensed ? '922px' : `1440px`)};
  padding: ${({ condensed, sectionContainer }) =>
    sectionContainer ? '0 80px 120px 80px' : condensed ? '36px' : '36px 80px'};
  position: ${({ sectionContainer }) => (sectionContainer ? 'relative' : 'default')};
  display: ${({ sectionContainer }) => (sectionContainer ? 'flex': '')};
  flex-direction: ${({ sectionContainer }) => (sectionContainer ? 'column': '')};
  align-items: ${({ sectionContainer }) => (sectionContainer ? 'center': '')};
  gap: ${({ awardContainer, sectionContainer }) => (awardContainer ? '60px' : sectionContainer ? '40px': '')};

  @media (max-width: ${media.mediumTop}) {
    padding: ${({ condensed, sectionContainer }) =>
      sectionContainer ? '0 20px 60px 20px' : condensed ? '36px' : '36px 20px'};
  }
`;

export { Container };
